import { render, staticRenderFns } from "./LeftSideTitleBar.vue?vue&type=template&id=0edb207a&scoped=true&"
import script from "./LeftSideTitleBar.vue?vue&type=script&lang=js&"
export * from "./LeftSideTitleBar.vue?vue&type=script&lang=js&"
import style0 from "./LeftSideTitleBar.vue?vue&type=style&index=0&id=0edb207a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edb207a",
  null
  
)

export default component.exports